import { styled } from '@mui/material';

export const TrlNumberStyled = styled('span')(({ fontFamily }) => ({
  fontFamily: fontFamily || 'Roboto Mono',
  fontWeight: !fontFamily && 500,
}));
